import React from 'react';
import { WidgetEditorProps } from '../../ContentMapping/ContentMapping';
import './Audio.css';

/**
 * Let the user create an embedded audio by specifying the link and a percentage width.
 * Height will be automatic based on the aspect ratio.
 *
 * Last Modified
 * Michael Tsien
 * October 11, 2022
 */


// TODO: This class is not using "controlled" form inputs. I would suggest switching it to controlled
// sometime in the future. For now it's fine because it works and we're under a deadline.
// TODO: Use the component within Audio.tsx instead of re-doing the audio logic.
export const AudioEditor: React.FC<WidgetEditorProps> = ({
	originalContent,
	editedContent,
	setEditedContentOnChange
}) => {
	let audioLink: string = editedContent.audio_audioLink || "";

	return <>
		<audio
			className="audio-player-auto-size"
			controls>
			<source src={audioLink} type="audio/mpeg" />
			Your browser does not support the audio element.
        </audio>
		<br />
		<h3>Audio Link (only supports mp3 or mpeg)</h3>
		<input type="text" value={audioLink}
			onChange={(e) => setEditedContentOnChange("audio_audioLink", e.target.value)} />
	</>;
}